export const FIRST_NAME = 'First name';
export const LAST_NAME = 'Last name';
export const EMAIL = 'Email';
export const PHONE_NUMBER = 'Phone number';
export const ZIPCODE = 'ZIP code';
export const SCHOOL_PREMIUM_ESTIMATE = 'Estimated number of schools that will receive Quill Premium';
export const TEACHER_PREMIUM_ESTIMATE = 'Estimated number of teachers that will receive Quill Premium';
export const STUDENT_PREMIUM_ESTIMATE = 'Estimated number of students that will receive Quill Premium';
export const COMMENTS = 'Comments';
export const SCHOOL = 'School';
export const DISTRICT = 'District';
export const SCHOOL_OR_DISTRICT = 'School or district';
export const SCHOOL_NOT_LISTED = "My school isn’t listed";
export const DISTRICT_NOT_LISTED = "My district isn’t listed";
export const COLLECTION_TYPE = 'School or district selection';
export const SUBMISSION_ERROR = 'Submission error';
export const PROPERTIES = ['first_name', 'last_name', 'email', 'phone_number', 'zipcode', 'collection_type', 'school_name', 'district_name', 'school_premium_count_estimate', 'teacher_premium_count_estimate', 'student_premium_count_estimate'];
export const NUMERICAL_PROPERTIES = ['school_premium_count_estimate', 'teacher_premium_count_estimate', 'student_premium_count_estimate'];
export const PROPERTY_LABELS = [FIRST_NAME, LAST_NAME, EMAIL, PHONE_NUMBER, ZIPCODE, COLLECTION_TYPE, SCHOOL, DISTRICT, SCHOOL_PREMIUM_ESTIMATE, TEACHER_PREMIUM_ESTIMATE, STUDENT_PREMIUM_ESTIMATE];
